<script lang="ts">
  import Icon from '@components/icon.svelte'
  export let firstPlayLocation: { yardLine: number; teamId: number } | undefined
  export let lastPlayLocation: { yardLine: number; teamId: number } | undefined
  export let fillColor: string | undefined = undefined
  export let possessionTeam: 'away' | 'home'
  export let opponentSide: boolean

  const markers = [
    { marker: '1', index: 0 },
    { marker: '2', index: 1 },
    { marker: '3', index: 2 },
    { marker: '4', index: 3 },
    { marker: '5', index: 4 },
    { marker: '4', index: 5 },
    { marker: '3', index: 6 },
    { marker: '2', index: 7 },
    { marker: '1', index: 8 },
  ]

  $: start = firstPlayLocation?.yardLine ?? 0
  $: yards =
    firstPlayLocation?.teamId !== lastPlayLocation?.teamId
      ? (100 -
          (firstPlayLocation?.yardLine ?? 0) -
          (lastPlayLocation?.yardLine ?? 0)) *
        (opponentSide ? -1 : 1)
      : opponentSide
      ? (firstPlayLocation?.yardLine ?? 0) - (lastPlayLocation?.yardLine ?? 0)
      : (lastPlayLocation?.yardLine ?? 0) - (firstPlayLocation?.yardLine ?? 0)
</script>

<div class="h-8 border border-current px-5 rounded-full">
  <div class="relative h-full">
    <div
      class="absolute h-full opacity-40"
      style:width={Math.abs(yards) + '%'}
      style:background={fillColor ?? 'currentColor'}
      style:left={possessionTeam === 'away'
        ? yards < 0
          ? (opponentSide ? 100 - start : start) + yards + '%'
          : (opponentSide ? 100 - start : start) + '%'
        : ''}
      style:right={possessionTeam === 'home'
        ? yards < 0
          ? (opponentSide ? 100 - start : start) + yards + '%'
          : (opponentSide ? 100 - start : start) + '%'
        : ''}
    />
    <div class="flex justify-evenly h-full border-x border-current">
      {#each markers as marker (marker.index)}
        <div class="flex items-center justify-center relative">
          <p class="absolute right-full">{marker.marker}</p>
          <div class="bg-current h-full" style="width: 1px"></div>
          <p class="absolute left-full">0</p>
        </div>
      {/each}
    </div>
  </div>
</div>
<div class="h-2 px-5">
  <div class="relative h-full">
    <Icon
      name="football-arrow"
      class={`absolute w-5 h-5 -mt-1 ${
        possessionTeam === 'away' ? '-translate-x-1/2' : 'translate-x-1/2'
      } ${possessionTeam === 'home' ? 'rotate-180' : ''}`}
      style={`left:${
        possessionTeam === 'away'
          ? yards < 0
            ? (opponentSide ? 100 - start : start) + yards + '%'
            : (opponentSide ? 100 - start : start) + yards + '%'
          : ''
      };right:${
        possessionTeam === 'home'
          ? yards < 0
            ? (opponentSide ? 100 - start : start) + yards + '%'
            : (opponentSide ? 100 - start : start) + yards + '%'
          : ''
      };`}
    />
  </div>
</div>
